<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Вы уверены, что хотите {{ type === 'block' ? 'архивировать' : 'разблокировать'}} профиль {{ selectedUsers?.length ? 'пользователей' : 'пользователя'}}?</h2>
    </div>
    <a-divider style="margin: 16px 0" />

    <div class="modal-no-padding__body">
      <p v-if="type === 'block'" class="modal-text">
        После архивации профиль станет неактивен и {{ selectedUsers?.length ? 'сотрудники' : 'сотрудник' }} не сможет зайти в свой профиль.
      </p>
      <p v-else class="modal-text">
        Профиль станет активен и {{ selectedUsers?.length ? 'сотрудники' : 'сотрудник' }} сможет зайти в свой профиль.
      </p>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button class="primary-button" :loading="modalActionLoading" @click="handleBlock">Архивировать</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {ref} from "@vue/runtime-core";

export default {
  props: {
    open: Boolean,
    currentActionUser: Object,
    selectedUsers: Array,
    type: String,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);
    const groupToCopyIn = ref();

    const handleBlock = () => {
      modalActionLoading.value = true;
      let users = [];
      if (props.currentActionUser?.id) {
        users.push(props.currentActionUser?.id);
      } else {
        users = props.selectedUsers;
      }

      store.dispatch('users/setStaffStatus', {users: users, is_active: props.type === 'block' ? 0 : 1})
          .then(() => {
            context.emit('submitted');
            message.success('Данные обновлены');
          }).finally(() => {
            modalActionLoading.value = false;
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    return {
      groupToCopyIn,
      modalActionLoading,
      closeForm,
      handleBlock
    }
  }
}
</script>

<style scoped lang="scss">

</style>